import { ActionReducer, MetaReducer } from '@ngrx/store';
import { AppState } from '.';

export function localStorageSyncReducer(reducer: ActionReducer<AppState>): ActionReducer<AppState> {
  return function (state, action) {
    const isInit = state === undefined;

    // Let reducers build the next state first
    let nextState = reducer(state, action);

    // Rehydrate only once (on init)
    if (isInit) {
      try {
        if (typeof window !== 'undefined' && window.localStorage) {
          const storedAuth = window.localStorage.getItem('auth');
          if (storedAuth) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const parsedAuth = JSON.parse(storedAuth) as any;

            // Convert date strings back to Date objects for proper AuthGuard comparisons
            if (parsedAuth.expiresAt) {
              parsedAuth.expiresAt = new Date(parsedAuth.expiresAt);
            }
            if (
              parsedAuth.temporaryAccessExpiration &&
              typeof parsedAuth.temporaryAccessExpiration === 'string'
            ) {
              parsedAuth.temporaryAccessExpiration = new Date(parsedAuth.temporaryAccessExpiration);
            }
            if (!Array.isArray(parsedAuth.userLoggedCustomCompanies)) {
              parsedAuth.userLoggedCustomCompanies = [];
            }

            nextState = {
              ...nextState,
              auth: parsedAuth,
            };
          }

          const storedPageFilterCompanyIds = window.localStorage.getItem('pageFilterCompanyIds');
          if (storedPageFilterCompanyIds) {
            const parsedPageFilterCompanyIds = JSON.parse(storedPageFilterCompanyIds);
            if (Array.isArray(parsedPageFilterCompanyIds)) {
              nextState = {
                ...nextState,
                global: {
                  ...nextState.global,
                  pageFilterCompanyIds: [
                    ...new Set(parsedPageFilterCompanyIds.map(id => String(id)).filter(Boolean)),
                  ].sort(),
                },
              };
            }
          }

          window.localStorage.removeItem('selectedCompanyIds');
        }
      } catch {
        // ignore
      }
    }

    // Persist auth on every action (best-effort)
    try {
      if (typeof window !== 'undefined' && window.localStorage) {
        window.localStorage.setItem(
          'auth',
          JSON.stringify(
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (nextState as any)?.auth ?? null
          )
        );
        const pageFilterCompanyIds = (nextState as AppState)?.global?.pageFilterCompanyIds;
        if (pageFilterCompanyIds === null) {
          window.localStorage.removeItem('pageFilterCompanyIds');
        } else {
          window.localStorage.setItem(
            'pageFilterCompanyIds',
            JSON.stringify(pageFilterCompanyIds ?? [])
          );
        }
        window.localStorage.removeItem('selectedCompanyIds');
      }
    } catch {
      // ignore
    }

    return nextState;
  };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const metaReducers: MetaReducer<any>[] =
  typeof window !== 'undefined' && window.localStorage ? [localStorageSyncReducer] : [];
